export default "__VITE_ASSET__D8IVo3rc__"